import React, { useEffect, useContext, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchConsultationById, putCompleteConsultation } from '../../../redux/actions/consultationActions';
import { fetchAnthropometryData } from '../../../redux/actions/anthropometryActions';
import { fetchPatients, fetchPersonById } from '../../../redux/actions/relatedEntitiesActions';
import { fetchDietById, fetchDietByPatientId } from '../../../redux/actions/dietActions';
import { clearAnthropometry } from '../../../redux/slices/anthropometrySlice';
import { clearCurrentDiet } from '../../../redux/slices/dietSlice';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { sendEmail, emailConsultationPdf } from '../../../service/api';
import { printPdf } from '../../../service/pdf/generateConsultationPdf';
import { generateConsultationPdf } from '../../../service/pdf/generateConsultationPdf';
import { AuthContext } from '../../../context/auth';
import ModalForms from '../../../components/ConfirmationModal/ModalForms';
import ConfirmationModal from '../../../components/ConfirmationModal/ConfirmationModal';
import { useModalFeedback } from '../../../context/ModalContext';
import Accordion from '../../../components/Accordion/Accordion';

import { MdEmail, MdPrint, MdExitToApp, MdEdit, MdDangerous, MdDoorBack, MdFireExtinguisher, MdMedicalServices } from 'react-icons/md';
import { FaUserMd, FaUser, FaCoffee, FaAppleAlt, FaUtensils, FaPizzaSlice, FaIceCream, FaDrumstickBite, FaBreadSlice, FaClipboardList, FaPills, FaStethoscope, FaWeight, FaRulerVertical, FaCalculator, FaPercentage, FaTransgenderAlt, FaCalendar, FaPlusCircle, FaMinusCircle } from "react-icons/fa";
import { BiMailSend } from "react-icons/bi";
import {
  formatDate, formatTime, formatStatus, formatDietName, formatGender,
  formatedClassifyBray
} from '../../../utils/functionsFormatPatterns/functionFormatConsultation';

import { calculateAge } from '../../../utils/Functions/formatPersons';
import showConsultationPdf from '../../../utils/PDF/showConsultationPdf';
import '../styles/ShowConsultation.css';
import '../styles/ConsultationAccordion.css';
import '../../../Mobile.css';
import { clearConsultation } from '../../../redux/slices/consultationSlice';
import LoadingEllipsis from '../../../components/LoadingEllipsis/LoadingEllipsis';


const ShowConsultation = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { consultation_id } = useParams();
  const { loginUser, hasAnyRole } = useContext(AuthContext);
  const {
    showConfirmation,
    showInfo,
    setIsDeleting,
    hideModal
  } = useModalFeedback();


  const [isSendingEmail, setIsSendingEmail] = useState(false);
  const [isGeneratingPdf, setIsGeneratingPdf] = useState(false);

  const { currentConsultation, loading: consultationLoading, error: consultationError } = useSelector(state => state.consultations);
  const { anthropometryData, loading: anthropometryLoading, error: anthropometryError } = useSelector((state) => state.anthropometry);
  const { person, loading: personLoading, error: personError } = useSelector((state) => state.relatedEntities);
  const { diets = [], loading: currentDietLoading, error: dietError } = useSelector((state) => state.diets);
  const currentDiet = diets.length > 0 ? diets : [];
  const dietId = currentDiet.length > 0 ? currentDiet[0].diet_id : null;

  const addressDetails = "Clique para ver no mapa";

  const hasRole = (role) => loginUser.roles?.includes(role);

  // Consulta principal - deve ser o único lugar onde fetchConsultationById é chamado
  useEffect(() => {
    if (consultation_id) {
      dispatch(fetchConsultationById(consultation_id));
    }
  }, [consultation_id, dispatch]);

  // Demais requisições devem depender exclusivamente dos dados da consulta
  useEffect(() => {
    if (currentConsultation?.patient_id) {
      dispatch(fetchAnthropometryData(currentConsultation.patient_id));
      dispatch(fetchPersonById(currentConsultation.patient_id));
      dispatch(fetchDietByPatientId(currentConsultation.patient_id));
    }
  }, [currentConsultation?.patient_id, dispatch]);

  // Logs para depuração
  useEffect(() => {
    console.log("ShowConsultation.js:79 Login User:", loginUser);
    console.log("ShowConsultation.js:80 Roles do usuário logado:", loginUser?.roles);
    if (loginUser?.roles) {
      console.log("ShowConsultation.js:82 Usuário tem a role 'Admin'.", hasRole('Admin'));
    }
    console.log("ShowConsultation.js:85 currentConsultation:", currentConsultation);
    console.log("ShowConsultation.js:86 currentConsultation Status:", currentConsultation?.status);
    console.log("ShowConsultation.js:87 É Admin e Status NÃO é 'completed' (para botão Editar):", hasRole('Admin') && currentConsultation?.status !== 'completed');
    console.log("ShowConsultation.js:88 É Admin (para botão Finalizar):", hasRole('Admin'));
  }, [loginUser, currentConsultation, hasRole]);

  if (consultationLoading || personLoading || anthropometryLoading) {
    return <LoadingEllipsis message="Carregando detalhes da consulta..." />;
  }

  if (consultationError || personError) {
    return <div>Erro: {consultationError || personError}</div>;
  }

  if (!currentConsultation) {
    return <div>Nenhuma consulta encontrada.</div>;
  }

  if (!person) {
    // console.error("Paciente não encontrado:", currentConsultation?.patient_id);
    return <div>Paciente não encontrado.</div>;
  }

  const getMealIcon = (mealName) => {
    switch (mealName.toLowerCase()) {
      case "café da manhã":
        return <FaCoffee className="icon" />;
      case "lanche da manhã":
        return <FaAppleAlt className="icon" />;
      case "almoço":
        return <FaUtensils className="icon" />;
      case "lanche da tarde":
        return <FaPizzaSlice className="icon" />;
      case "jantar":
        return <FaDrumstickBite className="icon" />;
      case "ceia":
        return <FaIceCream className="icon" />;
      default:
        return <FaUtensils className="icon" />; // Ícone padrão
    }
  };

  // Função para redirecionar para a página de Nova Antropometria
  const handleNewAnthropometry = () => {
    if (currentConsultation?.patient_id) {
      navigate('/home/anthropometry/create', {
        state: {
          appointment_id: currentConsultation?.appointment_id,
          patient_id: currentConsultation?.patient_id,
          professional_id: currentConsultation?.professional_id,
          consultation_id: currentConsultation?.consultation_id,
        }
      });
      // console.log(appointmentDetails.patient_id);
      // console.log(`Enviando para Antropometria
      //   PacienteId: ${currentConsultation?.patient_id}, 
      //   ProfissionalId: ${currentConsultation?.professional_id}, 
      //   ConsultaId: ${currentConsultation?.consultation_id}, 
      //   AgendamentoId: ${currentConsultation?.appointment_id}`);
    } else {
      alert('Paciente não encontrado.');
    }
  };

  const handleEdit = () => {
    // Verifica se há uma dieta associada
    const dietId = Array.isArray(currentDiet) && currentDiet.length > 0 ? currentDiet[0].diet_id : null;

    navigate(`/home/consultation/update/${consultation_id}`, {
      state: {
        consultation_id: currentConsultation?.consultation_id,
        patient_id: currentConsultation?.patient_id,
        appointment_id: currentConsultation?.appointment_id,
        diet_id: dietId,
        company_id: currentConsultation?.company_id,
        professional_id: currentConsultation?.professional_id,
      },
    });
  };

  const handleFinishOrReopen = async () => {
    try {
      const action =
        currentConsultation.status === 'completed'
          ? { consultation_id, status: 'in_progress' }
          : { consultation_id, status: 'completed' };

      await dispatch(putCompleteConsultation(action)).unwrap();

      const newStatusMessage = action.status === 'completed' ? 'finalizada' : 'reaberta';
      showInfo(`Consulta ${newStatusMessage} com sucesso!`);

      setTimeout(() => {
        navigate('/home/consultation/get');
      }, 2000);
    } catch (error) {
      console.error('Erro ao alterar status da consulta:', error);
      showInfo(`Erro ao alterar status da consulta: ${error.message || error}`, 3000);
      setTimeout(() => {
        navigate('/home/consultation/get');
      }, 3000);
    }
  };

  const handleConfirmAction = () => {
    const actionMessage =
      currentConsultation.status === 'completed'
        ? 'Deseja reabrir esta consulta?'
        : 'Deseja finalizar esta consulta?';

    showConfirmation(actionMessage, handleFinishOrReopen, hideModal);
  };

  const handleConfirmActionEmail = () => {
    showConfirmation(
      `Deseja enviar detalhes desta consulta para ${person.email}?`,
      handleEmail
    );
  };

  const handleEmail = async () => {
    try {
      setIsSendingEmail(true);

      showInfo(
        <>
          <BiMailSend className="ico" /> <LoadingEllipsis message=" Enviando e-mail..." />
        </>
      );

      const pdfBlob = await showConsultationPdf(currentConsultation, person, currentDiet, anthropometryData);

      const attachment = new File([pdfBlob], 'Consulta.pdf', { type: 'application/pdf' });
      const formData = new FormData();
      formData.append('to', person.email);
      formData.append('subject', 'Detalhes da Consulta');
      formData.append('text', 'Segue em anexo os detalhes da consulta.');
      formData.append('attachment', attachment);

      const timeoutPromise = new Promise((_, reject) =>
        setTimeout(() => reject(new Error("timeout")), 25000)
      );

      const response = await Promise.race([emailConsultationPdf(formData), timeoutPromise]);

      setIsSendingEmail(false);

      const email = formData.get('to');

      showInfo(
        <div className='message-line'>
          ✓ E-mail enviado para <BiMailSend className="ico" /> {email}
        </div>
      );

      // Modal ficará visível por 4s
      setTimeout(() => {
        hideModal();
      }, 4000);
    } catch (error) {
      setIsSendingEmail(false);

      if (error.message === "timeout") {
        showInfo(
          <span className="spanDataTop">
            Humm, parece que isso está demorando muito :( Tente novamente mais tarde.
          </span>
        );
      } else {
        showInfo(
          <>
            <span className='spanDataTop'>Falha ao enviar o e-mail para</span> <span className="spanDataTop">{person.email}</span>.
          </>
        );
      }

      setTimeout(() => {
        hideModal();
      }, 4000);
    }
  };


  const handlePrint = async (currentConsultation, person, dietData, anthropometryData) => {
    setIsGeneratingPdf(true);
    try {
      await printPdf(currentConsultation, person, dietData, anthropometryData);
    } finally {
      setIsGeneratingPdf(false);
    }
    //showConsultationPdf(currentConsultation, person, dietData, anthropometryData, true);
  };


  const handleBack = () => {
    navigate(`/home/consultation/get`);
  };


  return (
    <div className='consultationGlobal'>
      <h3>Detalhes da Consulta</h3>

      {/* <div>
        <div>Agendamento Id: <span className="spanDataTitle">{currentConsultation.appointment_id}</span></div>
        <div>Paciente Id: <span className="spanDataTitle">{currentConsultation.patient_id}</span></div>
        <div>Consulta Id: <span className="spanDataTitle">{currentConsultation.consultation_id}</span></div>
        <div>Diet Id: <span className="spanDataTitle">{currentConsultation.diet_id}</span></div>
        <div>Diet Id: <span className="spanDataTitle">{dietId || 'Nenhuma dieta associada'}</span></div>
      </div> */}

      <form className="boxShowConsultation">
        {/* Dados da Consulta */}
        <h3>Consulta</h3>

        <div className="lineBoxTop">
          <div className="box-line">
            <div className="boxCol1">
              <label htmlFor="consult_date">Data da Consulta:</label>
              <span className="spanData">{formatDate(currentConsultation.consult_date)}</span>
            </div>
            <div className="boxCol1">
              <label htmlFor="status">Status da Consulta:</label>
              <span className="spanData">{formatStatus(currentConsultation.status)}</span>
            </div>
            <div className="boxCol1">
              <label htmlFor="start_time">Início da Consulta:</label>
              <span className="spanData">{formatTime(currentConsultation.start_time)}</span>
            </div>
            {currentConsultation?.status === 'completed' && (
              <div className="boxCol1">
                <label htmlFor="end_time">Encerramento da Consulta:</label>
                <span className="spanData">{formatTime(currentConsultation?.end_time)}</span>
              </div>
            )}
          </div>
          <div className="box-line">
            <div className="boxCol1">
              <label htmlFor="consultation_type_name">Consulta Tipo:</label>
              <span className="spanData">{currentConsultation.consultation_type?.name}</span>
            </div>
            <div className="boxCol1">
              <label htmlFor="consultation_type_description">Descrição:</label>
              <span className="spanData">{currentConsultation.consultation_type?.description}</span>
            </div>
            {/* <div className="boxCol1">
              <label htmlFor="consultation_type_default_fee">Tarifa:</label>
              <span className="spanData">
                {currentConsultation.consultation_type && currentConsultation.consultation_type.default_fee
                  ? `R$ ${currentConsultation.consultation_type.default_fee}`
                  : ''}
              </span>
            </div> */}
          </div>
          <div className="box-line">
            <div className="boxCol1">
              <label htmlFor="company_name">Empresa:</label>
              <span className="spanData">{currentConsultation.company_name}</span>
            </div>
            <div className="boxCol1">
              <label htmlFor="professional_name">Profissional:</label>
              <span className="spanData">{currentConsultation.professional_name}</span>
            </div>
          </div>
        </div>


        <h3>Paciente</h3>
        <div className="lineBoxTop">
          <div className="box-line">
            <div className="boxCol1">
              <label htmlFor="patient_name">Paciente:</label>
              <span className="spanData">{currentConsultation.patient_name}</span>
            </div>
            <div className="boxCol1">
              <label htmlFor="patient_name">Idade:</label>
              <span className="spanData">{calculateAge(person?.birth_date) || 'N/A'}</span>
            </div>
            <div className="boxCol1">
              <label htmlFor="patient_name">Gênero:</label>
              <span className="spanData">{formatGender(person?.gender) || 'N/A'}</span>
            </div>
            <div className="boxCol1">
              <label htmlFor="patient_name">CPF:</label>
              <span className="spanData">{person?.cpf || 'N/A'}</span>
            </div>
          </div>
        </div>

        <h3>Endereço</h3>
        <div className="lineBoxTop">
          <div className="boxCol1">
            {/* <label className='spanData' htmlFor="street">Logradouro:</label> */}
            <span className="spanData">
              <a
                data-tip={addressDetails}
                href={
                  person?.address?.street && person?.address?.number
                    ? `https://www.google.com/maps?q=${person?.address?.street} + ${person?.address?.number}`
                    : '#'
                }
                target="_blank"
                rel="noopener noreferrer"
              >
                {person?.address
                  ? `${person.address.street || ''}, ${person.address.number || ''} - 
        ${person.address.complement || ''} - 
        ${person.address.neighborhood || ''} - 
        ${person.address.city || ''} - 
        ${person.address.uf || ''} - 
        ${person.address.zipcode || ''}`
                  : 'Endereço não disponível'}
              </a>
            </span>

          </div>
        </div>

        {/* Conexões aos Databases */}
        <h3>Antropometria</h3>
        <div className="consultationLine" />
        {anthropometryData && anthropometryData.length > 0 ? (
          <div className="consultation-form-group">
            <ul className="anthropometry-list">
              <li className="anthropometry-item">
                <FaCalendar className="icon" />
                <span>Data: {formatDate(anthropometryData[0]?.measurement_date)}</span>
              </li>
              <li className="anthropometry-item">
                <FaRulerVertical className="icon" />
                <span>Altura: {anthropometryData[0]?.height} cm</span>
              </li>
              <li className="anthropometry-item">
                <FaWeight className="icon" />
                <span>Peso Atual: {anthropometryData[0]?.current_weight} kg</span>
              </li>
              <li className="anthropometry-item">
                <FaCalculator className="icon" />
                <span>IMC: {anthropometryData[0]?.bmi} kg/m²</span>
              </li>
              <li className="anthropometry-item">
                <FaUserMd className="icon" />
                <span>Classificação: {formatedClassifyBray(anthropometryData[0]?.bray_classification)}</span>
              </li>
              <li className="anthropometry-item">
                <FaPercentage className="icon" />
                <span>PG: {anthropometryData[0]?.body_fat_percentage} %</span>
              </li>
            </ul>
          </div>
        ) : (
          <>

            <span className='spanDataTitle'>Dados antropométricos não disponíveis. </span>

            {currentConsultation?.status !== 'completed' && (
              <button className="sendBtnSections" type="button" onClick={handleNewAnthropometry}>Nova Antropometria</button>
            )}
            {/* <button className="sendBtn" type="button" onClick={handleAllAnthropometry}>Todas Antropometrias</button> */}
            {/* <button className="sendBtn" onClick={() => navigate('/anthropometry-evolution')}>Evolução Antropométrica</button> */}


          </>
        )}


        {/* dietas */}
        <h3>Dietas</h3>

        {Array.isArray(currentDiet) && currentDiet.length > 0 ? (
          currentDiet.map((diet) => (
            <div className='box-consult'>
              <Accordion
                key={diet.diet_id}
                data={diet.item}
                title={
                  <div className='accordionheaderline'>
                    <div className='headerLineTitle'><label>Nome:</label> <strong>{formatDietName(diet.name)}</strong></div>
                    <div className='headerLineTitle'><label>Criada em:</label> <strong>{formatDate(diet.created_at)}</strong></div>
                    <div className='headerLineTitle'><label>Objetivo:</label> <strong>{diet.objective}</strong></div>
                    <div className='headerLineTitle'><label>Total de Calorias:</label> <strong>{diet.diet_total_calories}</strong> kcal/dia</div>
                  </div>
                }
              >
                {/* Conteúdo do Accordion (Coluna B) */}
                <div className="diet-details">
                  {/* <div className="diet-objective">
                    <strong>Objetivo:</strong> {diet.objective}
                  </div> */}


                  {diet.meals?.length > 0 && (
                    <div className="box-diet-col-B">
                      {diet.meals.map((meal) => (
                        <div key={meal.meal_id} data={meal.item} className="meal-card">
                          <div className="meal-line">
                            <div className="label-card"><div className="label-icon">{getMealIcon(meal.name)}</div></div>
                            <div className="meal-title"><span className="spanDataTitle">{meal.name} {" "}</span> </div>
                            <div className="meal-time">Hora: <span className="spanDataTitle">{formatTime(meal.time)} {" "}</span></div>
                            <div className="meal-kcal">Calorias: <span className="spanDataTitle">{meal.total_calories}</span> kcal</div>
                          </div>

                          {meal.foods?.length > 0 && (
                            <div>
                              {meal.foods.map((food) => (

                                <div key={`${food.food_id}-${food.food_name}`} data={food.item} className="food-line">
                                  <ul className='dietFoodLine'>
                                    <li>
                                      <div className="liCol">
                                        <label htmlFor="">Quant</label>
                                        <div><span className="spanDataTitle">{food.quantity}{" "} </span>{food.unit_measurement} {" "}</div>
                                      </div>
                                      <div className="liCol">
                                        <label htmlFor="">Alimento: </label>
                                        <div><span className="spanDataTitle">{food.food_name} {" "}</span></div>
                                      </div>
                                      <div className="liCol liCalories">
                                        <label htmlFor="">Calorias: </label>
                                        <div><span className="spanDataTitle">{food.calories}</span> kcal</div>
                                      </div>
                                    </li>
                                  </ul>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </Accordion>
            </div>
          ))
        ) : (
          <div className="no-diets-message">
            <span className="spanDataTitle">Não há dietas cadastradas para este paciente.</span>
            {currentConsultation?.status !== 'completed' && (
              <button
                className="sendBtnSections"
                type="button"
                onClick={() =>
                  navigate('/home/diet/create', {
                    state: {
                      appointment_id: currentConsultation?.appointment_id,
                      patient_id: currentConsultation?.patient_id,
                      consultation_id: currentConsultation?.consultation_id,
                      company_id: currentConsultation?.company_id,
                      professional_id: currentConsultation?.professional_id,
                    },
                  })
                }
              >
                Criar Nova Dieta
              </button>
            )}
          </div>
        )}



        <br />


        <h3>Anamnese Nutricional </h3>
        {/* 1 - Objetivo da Consulta */}

        <div className="lineBoxTop">
          <h3 className='askTitle'><span className='askSpan'>1</span> Objetivo da Consulta</h3>
          <div className="box-line">
            <div className="boxCol1">
              <label htmlFor="objectiveQ1">O que trouxe você até aqui:</label>
              <div className="anthropometry-item">
                {currentConsultation?.objectiveQ1 || 'N/A'}
              </div>
            </div>
          </div>
          <div className="box-line">
            <div className="boxCol1">
              <label htmlFor="objectiveQ2">Meta específica:</label>
              <div className="anthropometry-item">
                {currentConsultation?.objectiveQ2 || 'N/A'}
              </div>
            </div>
          </div>
          <div className="box-line">
            <div className="boxCol1">
              <label htmlFor="objectiveQ3">Dificuldade com a Alimentação:</label>
              <div className="anthropometry-item">
                {currentConsultation?.objectiveQ3 || 'N/A'}
              </div>
            </div>
          </div>
        </div>
        {/* 2 - Histórico Clínico Familiar */}
        <div className="lineBoxTop">
          <h3 className='askTitle'><span className='askSpan'>2</span> Histórico Clínico Familiar</h3>
          <div className="box-line">
            <div className="boxCol1">
              <label htmlFor="procedures">Doenças Atuais:</label>
              <div className="spanDataProcedures">
                {Array.isArray(currentConsultation?.current_illnesses) && currentConsultation.current_illnesses.length > 0 ? (
                  currentConsultation.current_illnesses.map((illness) => (
                    <div key={illness} className="anthropometry-item">
                      {illness}
                    </div>
                  ))
                ) : (
                  <div className="anthropometry-item">N/A</div>
                )}
              </div>
            </div>
          </div>
          <div className="box-line">
            <div className="boxCol1">
              <label htmlFor="procedures">Doenças Prévias ou Crônicas:</label>
              <div className="spanDataProcedures">
                {Array.isArray(currentConsultation?.past_illnesses) && currentConsultation.past_illnesses.length > 0 ? (
                  currentConsultation.past_illnesses.map((illness) => (
                    <div key={illness} className="anthropometry-item">
                      {illness}
                    </div>
                  ))
                ) : (
                  <div className="anthropometry-item">N/A</div>
                )}
              </div>
            </div>
          </div>
          <div className="box-line">
            <div className="boxCol1">
              <label htmlFor="procedures">Alergias e Intolerâncias:</label>
              <div className="spanDataProcedures">
                {Array.isArray(currentConsultation?.allergies) && currentConsultation.allergies.length > 0 ? (
                  currentConsultation.allergies.map((allergy) => (
                    <div key={allergy} className="anthropometry-item">
                      {allergy}
                    </div>
                  ))
                ) : (
                  <div className="anthropometry-item">N/A</div>
                )}
              </div>
            </div>
          </div>
          <div className="box-line">
            <div className="boxCol1">
              <label htmlFor="procedures">Cirurgias e Hospitalizações:</label>
              <div className="spanDataProcedures">
                {Array.isArray(currentConsultation?.surgeries) && currentConsultation.surgeries.length > 0 ? (
                  currentConsultation.surgeries.map((surgery) => (
                    <div key={surgery} className="anthropometry-item">
                      {surgery}
                    </div>
                  ))
                ) : (
                  <div className="anthropometry-item">N/A</div>
                )}
              </div>
            </div>
          </div>
          <div className="box-line">
            <div className="boxCol1">
              <label htmlFor="procedures">Medicamentos:</label>
              <div className="spanDataProcedures">
                {Array.isArray(currentConsultation?.medications) && currentConsultation.medications.length > 0 ? (
                  currentConsultation.medications.map((medication) => (
                    <div key={medication} className="anthropometry-item">
                      {medication}
                    </div>
                  ))
                ) : (
                  <div className="anthropometry-item">N/A</div>
                )}
              </div>
            </div>
          </div>
          <div className="box-line">
            <div className="boxCol1">
              <label htmlFor="procedures">Histórico Familiar:</label>
              <div className="spanDataProcedures">
                {Array.isArray(currentConsultation?.family_history) && currentConsultation.family_history.length > 0 ? (
                  currentConsultation.family_history.map((history) => (
                    <div key={history} className="anthropometry-item">
                      {history}
                    </div>
                  ))
                ) : (
                  <div className="anthropometry-item">N/A</div>
                )}
              </div>
            </div>
          </div>
        </div>
        {/* 3 - Histórico alimentar */}
        <div className="lineBoxTop">
          <h3 className='askTitle'><span className='askSpan'>3</span> Histórico Alimentar</h3>
          <div className="box-line">
            <div className="boxCol1">
              <label htmlFor="foodHistoryQ1">Quantas Refeições faz por dia:</label>
              <div className="anthropometry-item">
                {currentConsultation?.foodHistoryQ1 || 'N/A'}
              </div>
            </div>
          </div>
          <div className="box-line">
            <div className="boxCol1">
              <label htmlFor="foodHistoryQ2">Pula alguma refeição:</label>
              <div className="anthropometry-item">
                {currentConsultation?.foodHistoryQ2 || 'N/A'}
              </div>
            </div>
          </div>
          <div className="box-line">
            <div className="boxCol1">
              <label htmlFor="foodHistoryQ3">Hábito nas refeições:</label>
              <div className="anthropometry-item">
                {currentConsultation?.foodHistoryQ3 || 'N/A'}
              </div>
            </div>
          </div>
          <div className="box-line">
            <div className="boxCol1">
              <label htmlFor="foodHistoryQ4">Consumo entre refeições:</label>
              <div className="anthropometry-item">
                {currentConsultation?.foodHistoryQ4 || 'N/A'}
              </div>
            </div>
          </div>
          <div className="box-line">
            <div className="boxCol1">
              <label htmlFor="foodHistoryQ5">Paladar preferido:</label>
              <div className="anthropometry-item">
                {currentConsultation?.foodHistoryQ5 || 'N/A'}
              </div>
            </div>
          </div>
          <div className="box-line">
            <div className="boxCol1">
              <label htmlFor="foodHistoryQ6">Consumo de Fast-Food:</label>
              <div className="anthropometry-item">
                {currentConsultation?.foodHistoryQ6 || 'N/A'}
              </div>
            </div>
          </div>
          <div className="box-line">
            <div className="box-line">
              <div className="boxCol1">
                <label htmlFor="foodHistoryQ7">Restrição Alimentar:</label>
                <div className="anthropometry-item">
                  {currentConsultation?.foodHistoryQ7 || 'N/A'}
                </div>
              </div>
            </div>
          </div>
          <div className="box-line">
            <div className="boxCol1">
              <label htmlFor="foodHistoryQ8">Hábito de cozinhar:</label>
              <div className="anthropometry-item">
                {currentConsultation?.foodHistoryQ8 || 'N/A'}
              </div>
            </div>
          </div>
          <div className="box-line">
            <div className="boxCol1">
              <label htmlFor="foodHistoryQ9">Uso de Restaurantes / Delivery:</label>
              <div className="anthropometry-item">
                {currentConsultation?.foodHistoryQ9 || 'N/A'}
              </div>
            </div>
          </div>
        </div>
        {/* 4 - Hidratação */}
        <div className="lineBoxTop">
          <h3 className='askTitle'><span className='askSpan'>4</span> Hidratação</h3>
          <div className="box-line">
            <div className="boxCol1">
              <label htmlFor="hydrationQ1">Consumo diário de água (lts):</label>
              <div className="anthropometry-item">
                {currentConsultation?.hydrationQ1 || 'N/A'}
              </div>
            </div>
          </div>
          <div className="box-line">
            <div className="boxCol1">
              <label htmlFor="hydrationQ2">Outras bebidas:</label>
              <div className="anthropometry-item">
                {currentConsultation?.hydrationQ2 || 'N/A'}
              </div>
            </div>
          </div>
          <div className="box-line">
            <div className="boxCol1">
              <label htmlFor="hydrationQ3">Sente sede constantemente:</label>
              <div className="anthropometry-item">
                {currentConsultation?.hydrationQ3 || 'N/A'}
              </div>
            </div>
          </div>
        </div>
        {/* 5 - Hábitos de Vida e Rotina */}
        <div className="lineBoxTop">
          <h3 className='askTitle'><span className='askSpan'>5</span> Hábitos de Vida e Rotina</h3>
          <div className="box-line">
            <div className="boxCol1">
              <label htmlFor="habitsQ1">Prática de Atividade Física:</label>
              <div className="anthropometry-item">
                {currentConsultation?.habitsQ1 || 'N/A'}
              </div>
            </div>
          </div>
          <div className="box-line">
            <div className="boxCol1">
              <label htmlFor="habitsQ2">Estresse diário:</label>
              <div className="anthropometry-item">
                {currentConsultation?.habitsQ2 || 'N/A'}
              </div>
            </div>
          </div>
          <div className="box-line">
            <div className="boxCol1">
              <label htmlFor="habitsQ3">Qualidade do sono:</label>
              <div className="anthropometry-item">
                {currentConsultation?.habitsQ3 || 'N/A'}
              </div>
            </div>
          </div>
          <div className="box-line">
            <div className="boxCol1">
              <label htmlFor="habitsQ4">Rotina par comer e dormir:</label>
              <div className="anthropometry-item">
                {currentConsultation?.habitsQ4 || 'N/A'}
              </div>
            </div>
          </div>
          <div className="box-line">
            <div className="boxCol1">
              <label htmlFor="habitsQ5">Consome álcool ou tabaco:</label>
              <div className="anthropometry-item">
                {currentConsultation?.habitsQ5 || 'N/A'}
              </div>
            </div>
          </div>
        </div>
        {/* 6 - Fatores Emocionais e Comportamentais */}
        <div className="lineBoxTop">
          <h3 className='askTitle'><span className='askSpan'>6</span> Fatores Emocionais e Comportamentais</h3>
          <div className="box-line">
            <div className="boxCol1">
              <label htmlFor="emotionalFactorsQ1">Ansiedade e Compulsão alimentar:</label>
              <div className="anthropometry-item">
                {currentConsultation?.emotionalFactorsQ1 || 'N/A'}
              </div>
            </div>
          </div>
          <div className="box-line">
            <div className="boxCol1">
              <label htmlFor="emotionalFactorsQ2">Come por impulso:</label>
              <div className="anthropometry-item">
                {currentConsultation?.emotionalFactors2 || 'N/A'}
              </div>
            </div>
          </div>
          <div className="box-line">
            <div className="boxCol1">
              <label htmlFor="emotionalFactorsQ3">Exageros:</label>
              <div className="anthropometry-item">
                {currentConsultation?.emotionalFactorsQ3 || 'N/A'}
              </div>
            </div>
          </div>
          <div className="box-line">
            <div className="boxCol1">
              <label htmlFor="emotionalFactorsQ4">O que deseja mudar:</label>
              <div className="anthropometry-item">
                {currentConsultation?.emotionalFactorsQ4 || 'N/A'}
              </div>
            </div>
          </div>
        </div>
        {/* 7 -  Suplementação e Consumo de Vitaminas */}
        <div className="lineBoxTop">
          <h3 className='askTitle'><span className='askSpan'>7</span> Suplementação e Consumo de Vitaminas</h3>
          <div className="box-line">
            <div className="boxCol1">
              <label htmlFor="supplementsQ1">Faz uso de vitaminas / suplementos:</label>
              <div className="anthropometry-item">
                {currentConsultation?.supplementsQ1 || 'N/A'}
              </div>
            </div>
          </div>
          <div className="box-line">
            <div className="boxCol1">
              <label htmlFor="supplementsQ2">Orientado por médico:</label>
              <div className="anthropometry-item">
                {currentConsultation?.supplementsQ2 || 'N/A'}
              </div>
            </div>
          </div>
        </div>
        {/* 8 - Plano e Expectativas */}
        <div className="lineBoxTop">
          <h3 className='askTitle'><span className='askSpan'>8</span> Plano e Expectativas</h3>
          <div className="box-line">
            <div className="boxCol1">
              <label htmlFor="expectationsQ1">O que espera:</label>
              <div className="anthropometry-item">
                {currentConsultation?.expectationsQ1 || 'N/A'}
              </div>
            </div>
          </div>
          <div className="box-line">
            <div className="boxCol1">
              <label htmlFor="expectationsQ3">Preferência / Restrição para o planejamento alimentar:</label>
              <div className="anthropometry-item">
                {currentConsultation?.expectationsQ3 || 'N/A'}
              </div>
            </div>
          </div>
          <div className="box-line">
            <div className="boxCol1">
              <label htmlFor="expectationsQ2">Disposição para mudança de hábitos:</label>
              <div className="anthropometry-item">
                {currentConsultation?.expectationsQ2 || 'N/A'}
              </div>
            </div>
          </div>
        </div>
        {/* 9 - Diagnóstico / Procediemntos */}
        <div className="lineBoxTop">
          <h3 className='askTitle'><span className='askSpan'>9</span> Diagnóstico / Procedimentos</h3>
          <div className="box-line">
            <div className="boxCol1">
              <label htmlFor="procedures">Procedimentos:</label>
              <div className="anthropometry-item">
                {currentConsultation?.procedures || 'N/A'}
              </div>
            </div>
          </div>
          <div className="box-line">
            <div className="boxCol1">
              <label htmlFor="diagnosis">Diagnóstico:</label>
              <div className="anthropometry-item">
                {currentConsultation?.diagnosis || 'N/A'}
              </div>
            </div>
          </div>
          <div className="box-line">
            <div className="boxCol1">
              <label htmlFor="diagnosis">Observações:</label>
              <div className="anthropometry-item">
                {currentConsultation?.observations || 'N/A'}
              </div>
            </div>
          </div>
        </div>

        {/* Botões de Ação */}
        <div className="boxButtons1">
          <button className="showBoxBtn" type="button" onClick={handleConfirmActionEmail}>
            <MdEmail className="sideIcoBtn" />
            <span className="sideBtnSpan">Email</span>
          </button>
        </div>
        <div className="boxButtons2">
          <button
            className="showBoxBtn"
            type="button"
            onClick={() => handlePrint(currentConsultation, person, currentDiet, anthropometryData)}
          >
            {isGeneratingPdf ? <> <div className="pdf-loading-spinner"><span className="spinner" /></div>  <span className="sideBtnSpan">Gerando PDF...</span></> : (<><MdPrint className="sideIcoBtn" /> <span className="sideBtnSpan">Imprimir</span></>)}
          </button>
        </div>
        {/* Botão de Editar */}
        {
          hasAnyRole(['Developer', 'Admin', 'Professional', 'Nutritionist']) && (
            <>
              <div className="boxButtons3">
                <button
                  // className="showBoxBtn"
                  className={
                    currentConsultation.status === 'completed' ? 'showBoxBtn-disable' : 'showBoxBtn'
                  }
                  type="button"
                  onClick={handleEdit}
                  disabled={currentConsultation.status === 'completed'} // Condição para desabilitar

                  // Estilização visual para indicar o estado
                  style={{
                    cursor: currentConsultation.status === 'completed' ? 'not-allowed' : 'pointer',
                    opacity: currentConsultation.status === 'completed' ? 0.6 : 1,
                  }}
                >
                  <MdEdit className="sideIcoBtn" />
                  <span className="sideBtnSpan">Editar</span>
                </button>
              </div>
              {/* <div className="boxButtons4">
                <button className="showBoxBtn" type="button" onClick={handleConfirmFinish}>
                  <MdMedicalServices className="sideIcoBtn" />
                  <span className="sideBtnSpan">Finalizar</span>
                </button>
              </div> */}
              <div className="boxButtons4">
                <button className="showBoxBtn" type="button" onClick={handleConfirmAction}>
                  <MdMedicalServices className="sideIcoBtn" />
                  <span className="sideBtnSpan">
                    {currentConsultation.status === 'completed' ? 'Reabrir Consulta' : 'Finalizar Consulta'}
                  </span>
                </button>
              </div>
            </>
          )
        }
        <div className="boxButtons5">
          <button className="showBoxBtn" type="button" onClick={handleBack}>
            <MdExitToApp className="sideIcoBtn" />
            <span className="sideBtnSpan">Voltar</span>
          </button>
        </div>
      </form >

    </div >
  );
};

export default ShowConsultation;
